import React, { useRef } from "react";
import {
  CustomText,
  Input,
  InputDate,
  SelectComponent,
} from "../../../components";
import { FormFull } from "form-full";
import { fonts } from "../../../config";

import { masks, validations } from "../../../utils";
import { StylesGuest } from "../styles";
import { FormHelperText } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import {

  Visibility,
} from "@mui/icons-material";
import { customModal } from "../../../components/modals/utils";


import "../../../phone.css";
import InputPhone from "../../../components/inputs/InputPhone";

function RenterForm({ onSubmit }) {
  const [fileName, setFileName] = React.useState<any>({});
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const fileRef = useRef<any | null>(null);
  const [docType, setDocType] = React.useState<any>(1);
  const [formRef, setFormRef] = React.useState<any>(null);
  //const phone = React.useRef<any>(null);
  //function setPhone(value) {
  //  phone.current = value;
  //}

  const handleImageChange = () => {
    // const savePhoto = (fileData: { src: string; name: string }) => {
    //  setFileName({ base: fileData.name });
    //  fileRef.current = { base: fileData?.src };
    //};
    // customModal.setInfos(
    //   "Cadastro da Facial",
    //   [],
    //   null,
    //   null,
    //   <WebcamModal onSubmit={savePhoto} />,
    //   false,
    //   false
    // );
  };

  const openModalViewImg = () => {
    customModal.setInfos(
      fileName.base,
      [],
      {
        onClick: () => {
          customModal.close();
        },
        label: "Voltar",
      },
      null,
      <div
        style={{
          paddingInline: "20px",
        }}
      >
        <div
          style={{
            borderRadius: "5px",
            maxHeight: "80vh",
            maxWidth: "80vw",
            height: "100%",
            width: "400px",
            minHeight: "300px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",

            backgroundImage: `url(${fileRef.current.base})`,
          }}
        />
      </div>,
      false,
      false
    );
  };

  function removerBase64EAntes(texto) {
    if (!texto) return null;

    const indiceBase64 = texto.indexOf("base64,");

    if (indiceBase64 !== -1) {
      return texto.substring(indiceBase64 + 7);
    }

    return texto;
  }

  return (
    <>
      <>
        <StylesGuest.Container>
          <CustomText
            style={{ paddingBottom: "5px" }}
            fontSize={2.25}
            fontFamily={fonts.bold}
            textColor="#4D585A"
          >
            Cadastro de Dados
          </CustomText>
          <CustomText
            style={{ paddingBottom: "12px" }}
            fontSize={1.75}
            fontFamily={fonts.regular}
            textColor="#24272A"
          >
            A seguir, preencha seus dados adicionais para confirmar seu acesso :
          </CustomText>
          <FormFull
            formRef={setFormRef}
            onSubmit={(data: any) => {
              const submitData = {
                phone: data.phone,
                name: data.name,
                cpf: data.docType === 1 ? data.docValue : undefined,
                birthDate: masks.dataParaString(data.birthDate),
                email: data.email,
                image: removerBase64EAntes(fileRef.current.base),
                passport: data.docType === 2 ? data.docValue : undefined,
              };

              onSubmit(submitData);
            }}
          >
            <Grid alignItems="flex-start" container spacing={1}>
              <Grid item xs={12} md={6} lg={6}>
                <Input
                  required={"*Campo Obrigatório"}
                  validation={validations.isValidFullname}
                  label="NOME COMPLETO"
                  name={"name"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Input
                  validation={validations.isEmailValid}
                  label="E-MAIL"
                  name={"email"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <SelectComponent
                  required={"*Campo Obrigatório"}
                  name="docType"
                  label="TIPO DO DOCUMENTO"
                  defaultValue={1}
                  onBlurCustom={() => {
                    formRef?.testFieldError("docValue", true);
                  }}
                  onChangeCustom={(v) => {
                    setDocType(v);

                    formRef?.clearValue("docValue", false);

                    if (v === 1) {
                      formRef?.setFieldValidation(
                        "docValue",
                        validations.validateCPF
                      );
                    } else {
                      formRef?.setFieldValidation("docValue", (value) => {
                        return null;
                      });
                    }
                  }}
                  options={[
                    { value: 1, label: "CPF" },
                    { value: 2, label: "Passaporte" },
                  ]}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Input
                  required={"*Campo Obrigatório"}
                  mask={docType === 1 ? masks.CPF : undefined}
                  name="docValue"
                  label={docType === 1 ? "CPF" : "Passaporte"}
                  maskToSubmit={(e, ffHandler) => {
                    let type = ffHandler?.getValue("docType", false);

                    if (type === 1) {
                      return masks.removeNumberMask(e);
                    } else {
                      return e;
                    }
                  }}
                  validation={(e, ffHandler) => {
                    let type = ffHandler?.getValue("docType", false);

                    if (type === 1) {
                      return validations.validateCPF(e);
                    } else {
                      return undefined;
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <InputDate
                  maxDate={new Date()}
                  label="DATA NASCIMENTO"
                  name={"birthDate"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <InputPhone
                  required={"*Campo Obrigatório"}
                  label="Telefone"
                  name={"phone"}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <CustomText
                  fontSize={1.75}
                  fontFamily={fonts.semibold}
                  textColor="#4D585A"
                >
                  CADASTRO DA FACIAL*
                </CustomText>
                <StylesGuest.InputImage
                  style={{
                    backgroundColor: "#D39899",
                    borderColor: "red",
                    borderStyle: "solid",
                    borderWidth: "2px",
                  }}
                >
                  <StylesGuest.InputImageClick htmlFor={"fileInput"}>
                    {fileName?.base ? (
                      <CustomText
                        style={{
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          display: "block",
                        }}
                        textColor="#4D585A"
                        fontSize={2}
                        fontFamily={fonts.medium}
                      >
                        {fileName?.base}
                      </CustomText>
                    ) : (
                      <CustomText
                        textColor="#4D585A"
                        fontSize={2}
                        fontFamily={fonts.medium}
                      >
                        Clique aqui para cadastrar sua facial
                      </CustomText>
                    )}

                    <button
                      id="fileInput"
                      onClick={() => handleImageChange()}
                      style={{ display: "none" }}
                    ></button>
                  </StylesGuest.InputImageClick>
                  {fileName?.base && (
                    <StylesGuest.InputView
                      endIcon={<Visibility />}
                      fullWidth={false}
                      onClick={() => openModalViewImg()}
                    >
                      Visualizar
                    </StylesGuest.InputView>
                  )}{" "}
                </StylesGuest.InputImage>{" "}
                <FormHelperText
                  style={{ color: "#24272A" }}
                  error={false}
                ></FormHelperText>
              </Grid>
            </Grid>

            <StylesGuest.ButtonsContainer>
              <StylesGuest.Clear
                fullWidth={false}
                action="clear"
                onClick={() => {
                  if (fileInputRef?.current?.value) {
                    fileInputRef.current.value = "";
                  }

                  fileRef.current = null;
                  setFileName({});
                }}
              >
                Limpar Campos
              </StylesGuest.Clear>{" "}
              <StylesGuest.SendForm
                disabled={Object.keys(fileName).length < 1}
                fullWidth={false}
                action="submit"
                style={
                  Object.keys(fileName).length >= 1
                    ? {
                      backgroundColor: "red",
                      borderColor: "red",
                      borderStyle: "solid",
                      borderWidth: "2px",
                    }
                    : {}
                }
              >
                Confirmar dados
              </StylesGuest.SendForm>
            </StylesGuest.ButtonsContainer>
          </FormFull>
        </StylesGuest.Container>
      </>
    </>
  );
}

export default RenterForm;
